export enum UBIK_TRACKING_TYPES {
  EXPERIMENT = 'experiment',
  TREATMENT = 'treatment',
  CAMPAIGN = 'campaign',
  FEATURE_FLAG = 'featureFlag'
}
